import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { makeRoutes } from '../components/routes';
import { Services } from '../services/services';

// eslint-disable-next-line import/no-unresolved

// For Tailwind. Comes first due to reset.
import '../styles/app.css';

// Existing, pre-Tailwind SASS styles.
import '../scss/main.scss';

const startApp = async () => {
  const root = createRoot(document.querySelector('#root')!);

  if (import.meta.env.DEV) {
    const { worker } = await import('../msw/browser');

    try {
      await worker.start({
        // We want most of the app’s requests to happen without being intercepted,
        // so this suppresses the warnings when they happen.
        onUnhandledRequest: 'bypass',
      });
    } catch (e) {
      console.error(
        'MSW failed to start. Fixture VIS responses will not be available.',
        e
      );
    }
  }

  const services = new Services();
  const router = createBrowserRouter(
    makeRoutes(import.meta.env.MODE === 'production', services)
  );

  root.render(
    <React.StrictMode>
      <QueryClientProvider client={services.queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </React.StrictMode>
  );
};

startApp();
